import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/packagesSalesSaga";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";
import { Tooltip } from "react-tooltip";

const ExcludeZeroSessions = () => {
  const dispatch = useDispatch();
  const excludeZeroSessions = useSelector(
    (state) => state.packagesSales.selectedFilters.exclude_zero_sessions
  );
  const tooltipId = "excludeZeroSessionsTooltip";

  return (
    <>
      <div className="select-box-no-width" style={{ marginRight: "auto" }}>
        <p
          data-tooltip-id={tooltipId}
          data-tooltip-content="When toggled ON, all active packages that have less than 1 session will be excluded."
        >
          Exclude 0 session
        </p>
        <ToggleableButton
          isActive={excludeZeroSessions}
          isRadio
          title="exclude-zero-sessions"
          onClick={(data) => dispatch(actionCreators.updateExcludeZeroSessions(data))}
        />
      </div>
      <Tooltip id={tooltipId} className="toggleTooltip" />
    </>
  );
};

export default ExcludeZeroSessions;
